import { Base } from 'styled';
import styled from 'styled-components';

export const BREADCRUMBS_MOBILE_HEIGHT = 47;

export const Container = styled(Base)<{ $offset: number }>`
  display: flex;
  width: 100%;
  margin: 0 auto;
  border-bottom: ${({ theme }) => theme.borders['gray-10']};
  background-color: ${({ theme }) => theme.palette.common.white};
  position: sticky;
  top: ${({ $offset }) => `${$offset}px`};
  ${({ theme }) => theme.zIndex('tab-nav')};

  ${({ theme }) => theme.mediaQueries['max-sm']} {
    height: ${BREADCRUMBS_MOBILE_HEIGHT}px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    justify-content: center;
  }
`;

export const InnerContainer = styled.div`
  max-width: 48rem;
  display: flex;
  padding: 1rem;
  overflow-x: scroll;
  flex-direction: row-reverse;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  ${({ theme }) => theme.mediaQueries.md} {
    flex-grow: 1;
    flex-direction: row;
  }
`;
